module.exports = __webpack_public_path__ + "static/img/icon_class_phone.3e04d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_class_phone.png
// module id = 691X
// module chunks = 1